import { useEffect, useMemo } from 'react'

import throttle from 'lodash/throttle'
import { REMEMBER_ME } from 'constants/consts'
import { useAuthContext } from './auth'

const LAST_ACTIVITY_TIME = 'last-activity-time'
const ALLOWED_INACTIVE_TIME = 1000 * 60 * 60 // 1 hour
const CHECK_INTERVAL = 1000 * 60 // 1 minute

const getRememberMe = () => {
  const rawCookie = localStorage.getItem(REMEMBER_ME)
  return rawCookie === 'true'
}

const useListeners = (track: boolean, onInactive: () => void) => {
  useEffect(() => {
    if (!track) return

    const checkLastActivityTime = () => {
      const rawCookie = localStorage.getItem(LAST_ACTIVITY_TIME)
      if (!rawCookie) return

      const lastActivityTime = parseInt(rawCookie)
      const timeSinceLastActivity = Date.now() - lastActivityTime

      if (timeSinceLastActivity > ALLOWED_INACTIVE_TIME) {
        localStorage.removeItem(LAST_ACTIVITY_TIME)
        onInactive()
      }
    }

    // check on page first opening or reloading
    checkLastActivityTime()

    const activityListener = throttle(() => {
      localStorage.setItem(LAST_ACTIVITY_TIME, Date.now().toString())
    }, CHECK_INTERVAL)

    window.addEventListener('mousemove', activityListener)
    window.addEventListener('touchstart', activityListener)
    const intervalId = setInterval(checkLastActivityTime, CHECK_INTERVAL)

    return () => {
      window.removeEventListener('mousemove', activityListener)
      window.removeEventListener('touchstart', activityListener)
      clearInterval(intervalId)
    }
  }, [track])
}

const useInactivityTracker = () => {
  const { signOut } = useAuthContext()

  const rememberMe = useMemo(getRememberMe, [])

  useListeners(!rememberMe, signOut)
}

export const InactivityTracker = () => {
  useInactivityTracker()

  return null
}
